import React from "react";
import {Button, Form, Modal} from "semantic-ui-react";
import {useForm} from "react-hook-form";
import {postSupport, putCourseCategories} from "../../../../redux/actions";

const Help = ({help, setHelp, place_id, course_id}) => {

    const {register, handleSubmit, formState} = useForm({
        mode: 'onChange',
        defaultValues: {
            place_id,
            course_id,
            subject: '',
            message: ''
        }
    });

    const onSubmit = async data => {
        try {
            const res = await postSupport(data);

            alert("Mensagem enviada com sucesso, a resposta chegará em seu e-mail.");

            setHelp(false);
        } catch (e) {
            alert('error')
        }
    };

    const {isValid, isSubmitted, isSubmitting} = formState;

    return (
        <Modal
            open={help}
            size={"tiny"}
        >
            <Modal.Header>Enviar mensagem</Modal.Header>
            <Modal.Content>
                <Form onSubmit={handleSubmit(onSubmit)} loading={isSubmitting}>
                    <input type={'hidden'} name={'place_id'} defaultValue={place_id} ref={register()}/>
                    <input type={'hidden'} name={'course_id'} defaultValue={course_id} ref={register()}/>
                    <Form.Field>
                        <label>Assunto</label>
                        <input
                            name={'subject'}
                            ref={register({required: true})}
                            autoFocus
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Mensagem</label>
                        <textarea
                            name={'message'}
                            ref={register({required: true})}
                        />
                    </Form.Field>
                    <div style={{textAlign: "right"}}>
                        <Button
                            basic
                            type={"button"}
                            content={"Fechar"}
                            onClick={() => setHelp(false)}
                        />
                        <Button
                            positive
                            type={"submit"}
                            content={"Enviar"}
                            disabled={!isValid}
                        />
                    </div>
                </Form>
            </Modal.Content>
        </Modal>
    );
}

export default Help;